export enum ChannelNoiseReductionLevel {
	Low = 'LOW',
	Medium = 'MEDIUM',
	High = 'HIGH',
	Auto = 'AUTO'
}
